import "./ComImage.css";

export default function ComImage() {
  return (
    <div className="resImageContainer">
      <img
        src="/assets/images/residential.jpg"
        className="resImage"
        alt="Residential"
      />
      <h1 className="resText">Commercial Buildings</h1>
    </div>
  );
}
